export type STATUS_TYPE = 'idle' | 'pending' | 'succeeded' | 'failed';

export type IParams = {
  id: string;
};

export enum Language {
  english = 'en',
  spanish = 'es',
}

export enum PurchaseType {
  oneTime = 'oneTime',
  subscription = 'subscription',
}

export enum LeadActionType {
  note = 'note',
  followUp = 'followUp',
  scheduleTestDrive = 'scheduleTestDrive',
  requestFinance = 'requestFinance',
  requestEPricing = 'requestEPricing',
  requestWarranty = 'requestWarranty',
  requestLiveAgent = 'requestLiveAgent',
  requestVehicleTradeIn = 'requestVehicleTradeIn',
  requestVehicleHistory = 'requestVehicleHistory',
  requestVirtualWalkaround = 'requestVirtualWalkaround',
  requestGetPayments = 'requestGetPayments',
}

export enum CarAvailability {
  available = 'available',
  unAvailable = 'unAvailable',
  soldOut = 'soldOut',
}

export enum CarType {
  new = 'New',
  used = 'Used',
}

export enum InteractionType {
  cover = "cover",
  photos = "photos",
  description = "description",
  features = "features",
  specs = "specs",
  vehicleHistory = "vehicleHistory",
  virtualWalkaround = "virtualWalkaround",
  similarVehicles = "similarVehicles",
  contactDealer = "contactDealer",
  todaysPrice = "todaysPrice",
  financeApplication = "financeApplication",
  shareVehicle = "shareVehicle",
  testDrive = "testDrive",
  payments = "payments",
  valueTrade = "valueTrade",
}

